export default __webpack_public_path__ + "static/media/ic_award.8ff4556c.svg";